/** Model, thinking, chat-target and concurrency pickers of the input bar. */
export default {
  model: "Model {label}",
  concurrency: "Concurrency: {count} parallel agents",
  startingNewChat: "Starting a new chat",
  sendingTo: "Sending next message to {name}",
  sendingToInProject: "Sending next message to {name} in {project}",
  agentFallback: "agent",
  newChat: "New chat",
  continueCurrentChat: "Continue current chat",
  startNewChat: "Start a new chat",
  recent: "Recent",
  results: "Results",
  noCommandsMatch: "No commands match",
  noRecentTargets: "No recent chats or sub-agents",
  noTargetsMatch: "No chats or sub-agents match",
  free: "Free",
  more: "More",
  noModelsMatch: "No models match.",
  changeModelFailed: "Could not change the model. Please try again.",
  changeEffortFailed: "Could not change the thinking effort. Please try again.",
  bundled: "{runtime} bundled",
  cliNotDetected:
    "{runtime} CLI not detected — install it on this machine, then restart the Denker companion",
  loginRequiredCommand:
    "Login required — run '{command}' then click Refresh in Settings → Companion",
  loginRequired: "Login required — open Settings → Companion",
  savingSettings: "Saving settings…",
  searchModelsPlaceholder: "Search OpenCode models…",
  searchModels: "Search OpenCode models",
  thinking: "Thinking",
  unavailable: "Unavailable",
  thinkingLevel: "Thinking level",
  effortThinking: "{effort} thinking",
  effortDefault: "Default",
  effortMinimal: "Minimal",
  effortLow: "Low",
  effortMedium: "Medium",
  effortHigh: "High",
  effortXhigh: "Extra high",
  effortMax: "Max",
  effortUltra: "Ultra",
  statusOpen: "Open",
  statusArchived: "Archived",
  statusQueued: "Queued",
  statusRunning: "Running",
  statusTurnFailed: "Turn failed",
  statusTurnCancelled: "Turn cancelled",
  statusDeferred: "Deferred",
  statusWaitingForApproval: "Waiting for approval",
  statusPaused: "Paused",
  statusDone: "Done",
  statusFailed: "Failed",
  statusStopped: "Stopped",
  statusWaiting: "Waiting",
  statusUnavailable: "Unavailable",
} as const;
